<script lang="ts">
  import { Form } from "$ui/form";
  import * as yup from "yup";
  import { makeApiRequest } from "$lib/utils/api";
  import { selectedOrgStore } from "$lib/stores/orgs";
  import { toaster } from "$lib/utils/toaster";
  import Button from "$lib/ui/button/button.svelte";
  import type { SecurityFinding } from "$lib/stores/orgSecurityFindings";
  import FindingStatusSelect, { type FindingStatus } from "./FindingStatusSelect.svelte";

  let { finding }: { finding?: SecurityFinding } = $props();
  let shouldShowSaveButton = $state(false);
  const org = $selectedOrgStore;
  interface StatusUpdate {
    status?: FindingStatus;
    comment?: string;
  }
  let initialValues = {
    status: finding?.status,
  };
  const validationSchema = yup.object().shape({
    status: yup.string().required("Status cannot be empty"),
  });

  let form = $state();
  let validateField: (field?: any) => any;
  let isSubmitting = $state(false);
  let touched = $state();
  let errors = $state();

  const onSubmit = async (data: StatusUpdate) => {
    try {
      $isSubmitting = true;
      await makeApiRequest(`${org?.resourcePrefix}/findings/${finding.id}/status`, data, "PUT");
      shouldShowSaveButton = false;
    } catch (err) {
      toaster.error("Error", "Failed to update issue status. Please try again.");
      throw err;
    } finally {
      $isSubmitting = false;
    }
  };
  const onSuccess = () => {
    toaster.success("Success", "Issue status updated successfully");
  };
</script>

<Form
  {initialValues}
  {validationSchema}
  {onSubmit}
  {onSuccess}
  standaloneForm={false}
  bind:form
  bind:errors
  bind:validateField
  bind:isSubmitting
  bind:touched
>
  {#if $form}
    <div class="flex w-full items-center gap-2">
      <div class="flex-1 max-w-[220px]">
        <FindingStatusSelect
          value={$form.status}
          onChange={(selectedStatus) => {
            shouldShowSaveButton = $form.status !== selectedStatus;
            $form.status = selectedStatus;
          }}
          readonlyStatuses={["closed"]}
        />
      </div>
      {#if shouldShowSaveButton}
        <Button type="submit" disabled={$isSubmitting} size="sm">
          {#if $isSubmitting}
            Saving...
          {:else}
            Save
          {/if}
        </Button>
      {/if}
    </div>
  {/if}
</Form>
